import {
  ERROR_TECNICO,
  INDIVIDUO_NEGATIVO,
  RECHAZADO_OTROS,
  ERROR_NOSIS,
  RECHAZADO,
  GRACIAS,
  CUIT_NOVALIDA
} from "./step-constants";

import agroPasos from "@/config/brands/ofertaReactivo";

export const step1 = {
  APROBADO: "paso2",
  RECHAZADO_OTROS,
  INDIVIDUO_NEGATIVO,
  RECHAZADO_NOSIS_CALIFICACION_ACTIVA: RECHAZADO_OTROS,
  RECHAZADO: RECHAZADO_OTROS,
  ERROR_TECNICO
};

export const step2 = {
  APROBADO: "paso3",
  EXCEDIDO: "paso4",
  ERROR_NOSIS,
  RECHAZADO,
  ERROR_TECNICO,
  ERROR: ERROR_TECNICO
};

export const step4 = {
  GRACIAS,
  ERROR_TECNICO,
  ERROR: ERROR_TECNICO
};

export const stepsReactivo = {
  OFERTA: "oferta",
  ERROR_OFERTA: "errorOferta",
  GRACIAS
};

export const stepsAgro = {
  AGRO_PASO_2: "agropaso2",
  AGRO_PASO_3: "agropaso3",
  AGRO_PASO_4: "agropaso4",
  AGRO_PASO_5: "agropaso5",
  AGRO_SIN_OFERTA: "agroSinOferta",
  CUIT_NOVALIDA,
  AGRO_ES_CLIENTE: agroPasos.pasos.EsCliente.path,
  PATH_AGRO_PASO_2: agroPasos.pasos.agropaso2.path
};
